<template>
  <div :style="{'--radio-button-color': $store.getters.getRadioButtonColor}">

    <div v-for="model in question.answers" v-bind:key="model.uid">

      <label :for="question.uid"
             v-bind:class="{ selected: model.selected }"
             v-on:click="setRadio(model.uid)"
             class="radio visible-xs-block visible-sm-block visible-md-inline-block visible-lg-inline-block"
             style="padding-bottom:10px;padding-top:10px;">

        <input style="display:none;" type="radio"
               :name="question.uid"
               :v-bind:id="model.uid"
               :value="model.uid"
               v-bind:checked="model.selected">

        <div class="radio__text" :style="{'text-transform': question.config.answers_uppercase ? 'uppercase': ''}">{{ model.title}}&nbsp;&nbsp;</div>
      </label>
    </div>

    <!--<label
            :for="question.uid"
            v-bind:class="{ selected: model.selected }"
            v-on:click="setRadio(model.uid)"
            v-for="model in question.answers" v-bind:key="model.uid"
    >
        {{ model.title }}
        <div class="radio-icon" v-bind:style="{
                '--radio-icon-checked-path': `url(${radioButtonCheckedPath})`,
                '--radio-icon-unchecked-path': `url(${radioButtonUncheckedPath})`
            }"></div>
        <input style="display:none;" type="radio"
               :name="question.uid"
               :value="model.uid"
               v-bind:checked="model.selected">
    </label>-->
    <transition name="fade">
      <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
    </transition>
    <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
  </div>
</template>

<script>
import Vue from 'vue';
import Comment from './Comment';

export default {
  name: 'radio',
  props: ['question'],
  data() {
    return {
      answerSelected: false,
      showComment: false,
      commentPlaceholder: false,
      commentName: false,
      radioButtonCheckedPath: false,
      radioButtonUncheckedPath: false
    }
  },
  mounted() {
    this.radioButtonCheckedPath = this.$store.getters.getRadioButtonCheckedPath;
    this.radioButtonUncheckedPath = this.$store.getters.getRadioButtonUnCheckedPath;
  },
  methods: {
    setRadio: function (uid) {
      this.showComment = false;
      this.commentPlaceholder = false;
      this.commentName = false;

      this.$emit("inputClick", uid);

      this.question.answers.forEach((item, index) => {
        if (item.uid === uid) {
          item.selected = true;
          if (item.is_allow_comment) {
            this.showComment = true;
            this.commentPlaceholder = item.comment_placeholder;
            this.commentName = 'comment_' + this.question.uid;
          }
          Vue.set(this.question.answers, index, item);
        } else {
          item.selected = false;
          Vue.set(this.question.answers, index, item);
        }

        this.$emit("checkDependency", uid);
      });
    }
  },
  components: {
    Comment
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .10s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>
